import React, { useEffect, useState } from "react";
import Carousel from "@/components/ui/carousel/carousel";
import { SwiperSlide } from "swiper/react";
import { QUERY_ALL_BLOGS } from "@/framework/queries/blogs";
import { sanitize } from "@/framework/utils/sanitize";
import Image from "next/image";
import Link from "next/link";
import { useQuery } from "urql";
import { Post } from "./related-posts";
export default function PostCarousel({ activeCategory }) {
  const [items, setItems] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(1);
  const [fullyLoaded, setFullyLoaded] = useState(false);
  const [loadMoreData, setLoadMoreData] = useState(false);
  const [params, setParams] = useState({
    start: 0,
    limit: 10,
    sortBy: ["id:desc"],
    filter: {
      publishedAt: { ne: null },
    },
  });
  useEffect(() => {
    setItems([]);
  }, []);

  useEffect(() => {
    setItems([]);
    if (activeCategory === "All Blogs") {
      setParams((prevParams) => ({
        ...prevParams,
        start: 0,
        limit: 10,
        filter: {
          publishedAt: { ne: null },
        },
      }));
    } else {
      setParams((prevParams) => ({
        ...prevParams,
        start: 0,
        limit: 10,
        filter: {
          publishedAt: { ne: null },
          blog_categories: { name: { eq: activeCategory } },
        },
      }));
    }
  }, [activeCategory]);
  const [{ data, fetching: loading, error }] = useQuery({
    query: QUERY_ALL_BLOGS,
    variables: params,
    pause: !activeCategory,
  });
  useEffect(() => {
    if (data) {
      const newItems = data?.blogs?.data.map((row) => sanitize(row));
      if (!loadMoreData) {
        setItems(newItems);
      } else {
        setItems((prevItems) => [...prevItems, ...newItems]);
        setLoadMoreData(false);
      }
    }
  }, [data]);
  const handleLoadMore = () => {
    setLoadMoreData(true);
    setParams((prevParams) => ({
      ...prevParams,
      start: items?.length,
      limit: 10,
    }));
  };
  useEffect(() => {
    if (currentSlide > 0 && currentSlide % 8 === 0) {
      handleLoadMore();
    }
  }, [currentSlide]);

  const breakpoints = {
    1280: {
      slidesPerView: 2.4,
      spaceBetween: 30,
      slidesOffsetBefore: 32,
      slidesOffsetAfter: 32,
    },
    991: {
      slidesPerView: 2.2,
      spaceBetween: 20,
      slidesOffsetBefore: 32,
      slidesOffsetAfter: 32,
    },
    // when window width is >= 768px
    768: {
      slidesPerView: 1.4,
      spaceBetween: 20,
      slidesOffsetBefore: 32,
      slidesOffsetAfter: 32,
    },
    325: {
      slidesPerView: 1.1,
      spaceBetween: 15,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16,
    },
  };
  return (
    <div className="w-full lg:h-auto md:h-[540px] h-[400px]">
      <Carousel
        slidesPerView={2.4}
        spaceBetween={30}
        loop={false}
        className="featureCarousel w-full my-8"
        breakpoints={breakpoints}
        navigation={false}
        autoplay={{
          delay: 4500,
          disableOnInteraction: false,
        }}
        pagination={false}
        showNavAbove={false}
        setCurrentSlide={setCurrentSlide}

        // slidesOffsetAfter={20}
      >
        {items?.map((post, key) => (
          <SwiperSlide key={"Post" + key}>
            <Post data={post} />
          </SwiperSlide>
        ))}
      </Carousel>
    </div>
  );
}
